<template>
  <div class="container-full">
    <div class="menuFull">
      <ul>
        <li
          v-for="(itemMenu, index) in itemsMenuTranslated"
          :key="index"
          @click="actionToClick(itemMenu)"
        >
          {{ itemMenu.label }}
        </li>
      </ul>
    </div>    
    <Menu
      v-for="(itemMenu, index) in itemsMenuWithSubMenuTranslated"
      :key="index"
      :id="itemMenu.id"
      :ref="`${itemMenu.id}`"
      :model="itemMenu.items"
      :popup="true"
    />
    <div class="show-login">
      <LoginContainer/>
    </div>    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoginContainer from './container_login.vue'
export default {
  name: "MainMenu",
  components: {
    LoginContainer
  },  
  methods: {
    actionToClick(item) {
      if (item.to != "") {
        this.$router.push(item.to).catch(() => {});
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        return;
      }
      if (item.items.length > 0 && this.$refs[item.id]) {
        this.$refs[item.id][0].toggle(event);
      }
    },
  },
  computed: {
    ...mapGetters(["itemsMenuWithSubMenu","itemsMenu"]),
    itemsMenuTranslated() {
      return this.itemsMenu.map((item) => {
        return {
          ...item,
          label: this.$t(item.label),
        };
      });
    },
    itemsMenuWithSubMenuTranslated() {
      return this.itemsMenuWithSubMenu.map((item) => {
        return {
          ...item,
          items: item.items.map((subItem) => {
            return {
              ...subItem,
              label: this.$t(subItem.label),
            };
          }),
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-full {
  display: flex;
  width: 100%;
  background-color: #083078;
  height: 55px;
  /* padding-top: 10px;
  padding-bottom: 30px; */
}
.menuFull {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 80%;
}
.container-full ul {
  display: flex;
  color: #ffffff;
  text-decoration: none;
  list-style: none;
  height: 100%;
  align-items: center;
  margin: 0px auto;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
}
.container-full ul li {
  padding: 0px 20px;
  letter-spacing: 1px;
  transition: 0.3s all;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  user-select: none;
  font-size: 14px;
}

.container-full ul li:hover {
  color: #969696;
}

.show-login{
  display: flex;
  flex-wrap: wrap;
  width: 20%;
  justify-content: flex-end;
}

@media (max-width: 960px) {
  .menuFull {
    display: none;
  }  
  .show-login{
    display: none;
  }
  .container-full{
    display: none;
  }
}
</style>
